import {
  LayoutDashboard,
  CheckSquare,
  FolderKanban,
  Building2,
  Users,
  Calendar,
  Clock,
  Settings,
  Repeat,
  Tv,
  CreditCard,
  ShieldAlert,
  Plug,
  UserSquare2,
} from 'lucide-react';
import type { NavGroup } from '@miror/ui-web';

/**
 * NAV do Glivo Task. O gate agora é por PERMISSÃO (`meta.permission`, chave
 * plana task:<area>:<view>) — o editor de papel da suíte controla o que cada
 * user vê. super_admin bypassa; item sem `meta.permission` nem `superAdminOnly`
 * (ex.: Minha conta) aparece pra todos. `meta.prefix` ativa o destaque por
 * prefixo de rota (ex: /horas cobre /horas/dashboard).
 *
 * As chaves de permissão espelham exatamente o que a Sidebar por papel liberava
 * (as grants da migration 0097 dão a cada papel seu conjunto task:*).
 */
export const NAV_GROUPS: NavGroup[] = [
  {
    key: 'root',
    label: '',
    items: [
      { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, meta: { permission: 'task:dashboard:view' } },
      { to: '/tv?token=mirortask-tv-2026', label: 'TV Dash', icon: Tv, activePath: '/tv', meta: { permission: 'task:dashboard:view' } },
      { to: '/tasks', label: 'Tarefas', icon: CheckSquare, meta: { permission: 'task:tasks:view' } },
      { to: '/tasks/recorrencias', label: 'Recorrências', icon: Repeat, meta: { permission: 'task:recurrences:view' } },
      { to: '/projects', label: 'Projetos', icon: FolderKanban, meta: { permission: 'task:projects:view' } },
      { to: '/clientes', label: 'Clientes', icon: UserSquare2, meta: { permission: 'task:clients:view' } },
      { to: '/horas', label: 'Controle de Horas', icon: Clock, meta: { permission: 'task:hours:view', prefix: true } },
      { to: '/calendar', label: 'Calendário', icon: Calendar, meta: { permission: 'task:calendar:view' } },
    ],
  },
  // Grupo Administração — mesma divisão do Social/Pro (separador + label).
  {
    key: 'admin',
    label: 'Administração',
    trailingSeparator: true,
    items: [
      { to: '/empresa', label: 'Empresa', icon: Building2, meta: { permission: 'task:company:view' } },
      { to: '/users', label: 'Equipe & acessos', icon: Users, meta: { permission: 'task:team:view' } },
      { to: '/integracoes', label: 'Integrações', icon: Plug, meta: { permission: 'task:integrations:view' } },
      { to: '/plano-uso', label: 'Plano e uso', icon: CreditCard, meta: { permission: 'task:billing:view' } },
      // Minha conta é universal — sem gate (igual ao web do Pro).
      { to: '/settings', label: 'Minha conta', icon: Settings, meta: {} },
    ],
  },
  // Grupo Miror — só super admin (gate via meta.superAdminOnly no AppLayout).
  {
    key: 'miror',
    label: 'Glivo',
    trailingSeparator: true,
    items: [
      { to: '/painel-miror', label: 'Painel Miror', icon: ShieldAlert, meta: { superAdminOnly: true } },
    ],
  },
];
